import { isSameUTCDate } from './is-same-utc-date.js';
/**
 * method calculates whether given day is a valid date based on min and max.
 * Any dates prior to min and after max would result it `true` as it is not within range.
 */
export const isDateNotWithinRange = (day, min, max) => {
    // edge case: if same day as min or max, return false
    if ((min && isSameUTCDate(day, min)) || (max && isSameUTCDate(day, max)))
        return false;
    return (min && day < min) || (max && day > max) || false;
};
